module.exports = __webpack_public_path__ + "img/2.d8b8781a.png";